import filter from 'lodash/filter'
import some from 'lodash/some'
import {maybe} from '@freckle/maybe'

function isNullOrUndefined<A>(x?: A | null): boolean {
  return x === null || x === undefined
}

export function isNullOrUndefinedOrEmptyString<A>(x?: A | null): boolean {
  return isNullOrUndefined(x) || (typeof x === 'string' && x.trim().length === 0)
}

export function toggleMembership<A>(
  value: A,
  selections: Array<A>,
  mCompareFn?: (a: A, b: A) => boolean
): Array<A> {
  const predicate = maybe(
    () => (v: A) => value === v,
    compareFn => (v: A) => compareFn(v, value),
    mCompareFn
  )
  return some(selections, predicate)
    ? filter(selections, selection => !predicate(selection))
    : selections.concat([value])
}
